import { Box, Typography } from '@mui/material';
import CustomBR from '../../foundation/CustomBR';

const ElpWhatsappDemo = (): JSX.Element => (
    <Box textAlign="center">
        <Typography color="secondary" fontWeight="bold" variant="h4" marginBottom={1}>
            הסוכן AI שלנו בוואטסאפ
        </Typography>
        <CustomBR times={1} />
        <iframe
            src="/mploy-whatsapp-demo.html"
            title="WhatsApp Bot Demo"
            style={{
                width: '100%',
                height: '760px',
                border: 'none',
                borderRadius: '1rem',
                display: 'block',
            }}
        />
    </Box>
);

export default ElpWhatsappDemo;
